/* NANIMERICA · Early Black Friday access sign-ups (snippets/nr-ea.liquid).
   Submit: email -> Klaviyo list (client subscriptions API), then the code shows at once, is copied on tap and is
   applied to the bag (/discount/CODE). The Klaviyo flow on the list emails the code too.
   After sign-up (saved in this browser) every spot shows the code and the pop-up stays away.
   US/Canada: the confirmation offers an optional SMS step (first access to drops and restocks, Klaviyo list UGXD2q).
   Pop-up: targeting and timing by page, see popup() below.
   Early-access email links can carry ?ea=1 to mark the browser as signed up and apply the 30% on any device. */
(function () {
  if (window.nrEaReady) return;
  window.nrEaReady = true;
  var CO = 'Vsnxqk', REV = '2025-01-15', KEY = 'nr_ea', XKEY = 'nr_ea_x', AKEY = 'nr_ea_ap';
  var EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function ls(k, v) {
    try {
      if (v === undefined) return localStorage.getItem(k);
      if (v === null) localStorage.removeItem(k); else localStorage.setItem(k, v);
    } catch (e) { return null; }
  }
  function ss(k, v) {
    try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) { return null; }
  }
  function done() { return !!ls(KEY); }

  function applyCode(code) {
    ss(AKEY, '1');
    return fetch('/discount/' + encodeURIComponent(code) + '?redirect=%2Fcart.js', { credentials: 'same-origin' })
      .then(function () { document.dispatchEvent(new CustomEvent('theme:update:cart')); })
      .catch(function () {});
  }
  function showOk(root, fresh) {
    root.classList.add('is-done');
    var pre = root.querySelector('.nr-ea__pre'), ok = root.querySelector('.nr-ea__ok');
    if (pre) pre.hidden = true;
    if (ok) ok.hidden = false;
    if (!fresh) {
      root.classList.add('is-back');
      var t = root.querySelector('.nr-ea__ok-t[data-back]');
      if (t && t.getAttribute('data-back')) t.textContent = t.getAttribute('data-back');
    }
  }
  function allOk(fresh) {
    document.querySelectorAll('[data-nr-ea]').forEach(function (r) { showOk(r, fresh); });
  }
  function subscribe(email, src, list) {
    var body = { data: { type: 'subscription', attributes: { custom_source: src, profile: { data: { type: 'profile', attributes: { email: email, properties: { bf_early_access: true, bf_early_access_source: src, bf_early_access_page: location.pathname } } } } }, relationships: { list: { data: { type: 'list', id: list } } } } };
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + CO, {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', Accept: 'application/vnd.api+json', revision: REV },
      body: JSON.stringify(body)
    }).then(function (r) { if (!r.ok) throw new Error(String(r.status)); });
  }

  // Optional SMS (US/Canada only; the field is only rendered for those shopping countries): first access to drops and restocks.
  // +1 numbers only (10 digits, North American format). Unlike the email step, a failed call shows an error instead of success.
  var SKEY = 'nr_ea_sms', EMKEY = 'nr_ea_em';
  function subscribeSms(phone, email, src, list) {
    var attrs = { phone_number: phone, subscriptions: { sms: { marketing: { consent: 'SUBSCRIBED' } } }, properties: { sms_first_access: true, sms_first_access_source: src } };
    if (email) attrs.email = email;
    var body = { data: { type: 'subscription', attributes: { custom_source: src + ' · SMS', profile: { data: { type: 'profile', attributes: attrs } } }, relationships: { list: { data: { type: 'list', id: list } } } } };
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + CO, {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', Accept: 'application/vnd.api+json', revision: REV },
      body: JSON.stringify(body)
    }).then(function (r) { if (!r.ok) throw new Error(String(r.status)); });
  }
  function bindSms(root) {
    var sf = root.querySelector('form[data-sms]');
    if (!sf) return;
    if (ls(SKEY)) root.classList.add('has-sms');
    var se = sf.querySelector('.nr-ea__sms-e');
    sf.addEventListener('submit', function (e) {
      e.preventDefault();
      var inp = sf.querySelector('input[type="tel"]'), btn = sf.querySelector('button');
      var d = (inp.value || '').replace(/\D/g, '');
      if (d.length === 11 && d.charAt(0) === '1') d = d.slice(1);
      if (!/^[2-9]\d{2}[2-9]\d{6}$/.test(d)) {
        se.textContent = 'Please enter a 10-digit US or Canada mobile number.'; se.hidden = false; inp.focus();
        return;
      }
      se.hidden = true;
      var prev = btn.textContent; btn.disabled = true; btn.textContent = 'Adding…';
      subscribeSms('+1' + d, ss(EMKEY), root.getAttribute('data-src') || 'BF early access', sf.getAttribute('data-sms-list')).then(function () {
        ls(SKEY, '1');
        document.querySelectorAll('[data-nr-ea]').forEach(function (r) {
          var f2 = r.querySelector('form[data-sms]'), ok2 = r.querySelector('.nr-ea__sms-ok');
          if (f2) f2.hidden = true;
          if (ok2 && r === root) ok2.hidden = false;
        });
      }, function () {
        btn.disabled = false; btn.textContent = prev;
        se.textContent = "That didn't go through. Please try again."; se.hidden = false;
      });
    });
  }

  // Buy box: keep "This piece: $79 -> $55.30" on the finish/size the shopper has picked.
  function trackPrice(root) {
    var map = null;
    try { map = JSON.parse(root.getAttribute('data-prices') || 'null'); } catch (e) { map = null; }
    if (!map) return;
    var sec = root.closest('[id^="shopify-section"]') || document;
    var last = '';
    function sync() {
      var inp = sec.querySelector('form[data-product-form] input[name="id"]');
      var id = (inp && inp.value) || new URLSearchParams(location.search).get('variant') || '';
      if (!id || id === last || !map[id]) return;
      last = id;
      root.querySelectorAll('[data-ea-was]').forEach(function (el) { el.textContent = map[id][0]; });
      root.querySelectorAll('[data-ea-now]').forEach(function (el) { el.textContent = map[id][1]; });
      // A sold-out finish/size shows no price line (the rest of the card stays).
      root.querySelectorAll('[data-ea-line]').forEach(function (el) { el.hidden = map[id][2] === false; });
      if (root.hasAttribute('data-ea-line')) root.hidden = map[id][2] === false;
      root.querySelectorAll('[data-ea-noline]').forEach(function (el) { el.hidden = map[id][2] !== false; });
    }
    sync();
    setInterval(function () { if (!document.hidden) sync(); }, 400);
  }

  function bind(root) {
    if (root.getAttribute('data-ready')) return;
    root.setAttribute('data-ready', '1');
    if (root.hasAttribute('data-prices')) trackPrice(root);
    if (root.hasAttribute('data-ea-hint')) {
      root.addEventListener('click', function (e) {
        var card = document.getElementById('nr-ea-buybox');
        if (!card) return;
        e.preventDefault();
        card.scrollIntoView({ behavior: 'smooth', block: 'center' });
        var em = card.querySelector('input[type="email"]');
        if (em && !card.classList.contains('is-done')) setTimeout(function () { try { em.focus({ preventScroll: true }); } catch (x) {} }, 450);
      });
      return;
    }
    var code = root.getAttribute('data-code');
    bindSms(root);
    var cp = root.querySelector('[data-copy]');
    if (cp) cp.addEventListener('click', function () {
      var lab = cp.querySelector('span');
      var fin = function () { if (lab) { lab.textContent = 'Copied'; setTimeout(function () { lab.textContent = 'Copy'; }, 1600); } };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(fin, fin); else fin();
    });
    var f = root.querySelector('form:not([data-sms])');
    if (!f) return;
    var err = root.querySelector('.nr-ea__e');
    f.addEventListener('submit', function (e) {
      e.preventDefault();
      var inp = f.querySelector('input[type="email"]'), btn = f.querySelector('button');
      var email = (inp.value || '').trim();
      if (!EMAIL.test(email)) {
        if (err) { err.textContent = 'Please enter a valid email.'; err.hidden = false; }
        inp.focus();
        return;
      }
      if (err) err.hidden = true;
      var prev = btn.textContent;
      btn.disabled = true; btn.textContent = 'Unlocking…';
      var src = root.getAttribute('data-src'), list = root.getAttribute('data-list');
      var fin = function () {
        ls(KEY, '1');
        ss(EMKEY, email);
        applyCode(code);
        allOk(true);
        btn.disabled = false; btn.textContent = prev;
        try { if (window.klaviyo && window.klaviyo.identify) window.klaviyo.identify({ email: email }); } catch (x) {}
        try { document.dispatchEvent(new CustomEvent('nr:ea:signup', { detail: { source: src } })); } catch (x) {}
      };
      // The code is shown even if the sign-up call fails, so nobody is left stuck.
      subscribe(email, src, list).then(fin, fin);
    });
  }

  /* Pop-up: one well-timed ask per visit, only for people the product page card and the homepage band didn't reach.
     Never: once signed up (this browser), visitors arriving from our emails, in the first 5s, within 30s of Add to cart,
     while the cart drawer / menu / search / size guide / a video / any other pop-up is open, or while someone is typing.
     When, by page (phones / desktop):
       homepage     no timed pop-up (the band asks) / only on exit intent
       product      second product page, or ~30s on the page / only on exit intent (the card under Add to cart asks)
       everything else (collections, search, pages)  ~15s or a good scroll / the same, plus exit intent
     How often: once per visit; after a close, not again for 2 days; after 3 closes, never automatically again.
     After a close, the "30% off" tab reopens it any time. Phones: swipe the sheet down to close. */
  var NKEY = 'nr_ea_xn', SESKEY = 'nr_ea_pop_s', PDPKEY = 'nr_ea_pdp';
  var lastAtc = 0;
  document.addEventListener('submit', function (e) { var a = e.target && e.target.getAttribute && (e.target.getAttribute('action') || ''); if (a.indexOf('/cart/add') > -1) lastAtc = Date.now(); }, true);
  document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('[name="add"],[data-nr-cdset-add],[data-nr-cdup-go]')) lastAtc = Date.now(); }, true);
  document.addEventListener('cart-is-open', function () { lastAtc = Date.now(); });

  function visible(el) {
    if (!el) return false;
    var r = el.getBoundingClientRect();
    if (!r.width || !r.height) return false;
    var c = getComputedStyle(el);
    return c.display !== 'none' && c.visibility !== 'hidden' && c.pointerEvents !== 'none' && parseFloat(c.opacity) > 0.05;
  }
  function busy(d) {
    try {
      var m = window.Alpine && Alpine.store && Alpine.store('modals');
      if (m && ['leftDrawer', 'rightDrawer', 'quickBuyDrawer', 'modal', 'promo', 'popup'].some(function (k) { return m[k] && m[k].open; })) return true;
    } catch (x) {}
    var open = document.querySelector('dialog[open]');
    if (open && open !== d) return true;
    var others = document.querySelectorAll('[role="dialog"],[aria-modal="true"],[class^="size-modal-template"],[class*=" size-modal-template"]');
    for (var i = 0; i < others.length; i++) { if (!d.contains(others[i]) && visible(others[i])) return true; }
    var ae = document.activeElement;
    if (ae && (/^(INPUT|TEXTAREA|SELECT)$/.test(ae.tagName) || ae.isContentEditable)) return true;
    if (getComputedStyle(document.documentElement).overflow === 'hidden' || getComputedStyle(document.body).overflow === 'hidden') return true;
    return false;
  }

  function popup() {
    var d = document.querySelector('dialog[data-nr-ea-pop]');
    if (!d || d.getAttribute('data-ready')) return;
    d.setAttribute('data-ready', '1');
    var tab = document.querySelector('[data-nr-ea-tab]');
    var sheet = d.querySelector('.nr-ea--popup');
    function showTab() { if (tab && !done()) tab.hidden = false; }
    function openNow() {
      if (d.open) return;
      if (tab) tab.hidden = true;
      try { d.showModal(); } catch (e) { d.setAttribute('open', ''); }
      // Keep the phone keyboard down until they tap the field: focus the pop-up itself (no ring on the X), Tab goes to the X.
      d.setAttribute('tabindex', '-1'); d.style.outline = 'none'; d.style.boxShadow = 'none';
      try { d.focus({ preventScroll: true }); } catch (e) {}
    }
    d.addEventListener('click', function (e) {
      if (e.target === d || (e.target.closest && e.target.closest('[data-close]'))) d.close();
    });
    d.addEventListener('close', function () {
      if (sheet) sheet.style.transform = '';
      if (done()) { if (tab) tab.hidden = true; return; }
      ls(XKEY, String(Date.now()));
      ls(NKEY, String((parseInt(ls(NKEY), 10) || 0) + 1));
      showTab();
    });
    if (tab) tab.addEventListener('click', openNow);
    // Swipe the sheet down to close (phones)
    if (sheet) {
      var y0 = null, dy = 0;
      sheet.addEventListener('touchstart', function (e) { y0 = (d.scrollTop <= 0) ? e.touches[0].clientY : null; dy = 0; }, { passive: true });
      sheet.addEventListener('touchmove', function (e) { if (y0 === null) return; dy = Math.max(0, e.touches[0].clientY - y0); sheet.style.transform = dy ? 'translateY(' + dy + 'px)' : ''; }, { passive: true });
      sheet.addEventListener('touchend', function () { if (y0 === null) return; if (dy > 90) d.close(); else sheet.style.transform = ''; y0 = null; });
    }
    if (done()) return;
    if (ls(XKEY)) showTab();
    if ((parseInt(ls(NKEY), 10) || 0) >= 3) return;
    if (Date.now() - (parseInt(ls(XKEY), 10) || 0) < 2 * 864e5) return;
    if (ss(SESKEY)) return;
    // Arrived from one of our emails: already a subscriber who came to shop, so no email ask.
    if (/[?&](_kx|utm_medium=email|utm_source=klaviyo)/i.test(location.search)) { ss(SESKEY, '1'); return; }

    var tpl = d.getAttribute('data-tpl') || '';
    var desk = window.matchMedia('(min-width: 750px) and (hover: hover) and (pointer: fine)').matches;
    var t0 = Date.now(), shown = false, timer = null, retry = null;
    function cleanup() {
      clearTimeout(timer); clearTimeout(retry);
      window.removeEventListener('scroll', onScroll);
      document.removeEventListener('mouseout', onOut);
    }
    function tryOpen() {
      if (shown || done()) return cleanup();
      var wait = Math.max(5000 - (Date.now() - t0), 30000 - (Date.now() - lastAtc), 0);
      if (wait > 0 || busy(d)) { clearTimeout(retry); retry = setTimeout(tryOpen, Math.max(wait, 3000)); return; }
      shown = true; cleanup();
      ss(SESKEY, '1');
      ls(XKEY, String(Date.now()));
      openNow();
    }
    function onScroll() {
      var h = document.documentElement;
      if (h.scrollHeight > innerHeight * 1.5 && (h.scrollTop + innerHeight) / h.scrollHeight > 0.6) tryOpen();
    }
    function onOut(e) { if (!e.relatedTarget && e.clientY <= 0) tryOpen(); }

    if (desk) document.addEventListener('mouseout', onOut);
    if (tpl === 'index') {
      // the homepage band already asks: desktop exit intent only, nothing timed
    } else if (tpl === 'product') {
      if (!desk) {
        var n = (parseInt(ss(PDPKEY), 10) || 0) + 1; ss(PDPKEY, String(n));
        timer = setTimeout(tryOpen, n >= 2 ? 6000 : 30000);
      }
    } else {
      timer = setTimeout(tryOpen, 15000);
      window.addEventListener('scroll', onScroll, { passive: true });
    }
  }

  function scan() {
    // Links in the early-access emails carry ?ea=1: opening one marks this browser as signed up (any device) and applies the 30%.
    if (/[?&]ea=1(&|$)/.test(location.search) && document.querySelector('[data-nr-ea][data-code]')) ls(KEY, '1');
    document.querySelectorAll('[data-nr-ea]').forEach(bind);
    if (done()) {
      allOk(false);
      var c = document.querySelector('[data-nr-ea][data-code]');
      if (c && !ss(AKEY)) applyCode(c.getAttribute('data-code'));
    }
    popup();
  }
  function start() {
    scan();
    var tm = null;
    new MutationObserver(function (muts) {
      if (!muts.some(function (m) { return m.addedNodes && m.addedNodes.length; })) return;
      clearTimeout(tm);
      tm = setTimeout(function () {
        document.querySelectorAll('[data-nr-ea]:not([data-ready])').forEach(function (r) { bind(r); if (done()) showOk(r, false); });
      }, 200);
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
